import { createContext, useContext, useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { vscService } from "../_services/vscService";
import SystemContext from "../_context/systemContext";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { instance, accounts } = useMsal();
  const [user, setUser] = useState(null);
  const [userInDatabase, setUserInDatabase] = useState(null);
  const [loading, setLoading] = useState(true);
  const System = useContext(SystemContext);

  /* 🔐 LOGIN MICROSOFT */
  const login = () => {
    instance.loginRedirect({
      scopes: ["User.Read"],
      redirectUri: "/auth-callback",
    });
  };

  /* 🔓 LOGOUT */
  const logout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  /* 🧠 CUANDO MSAL CAMBIA */
  useEffect(() => {
    const validarUsuario = async () => {
      if (!accounts.length) {
        setUser(null);
        setUserInDatabase(false);
        setLoading(false);
        return;
      }

      const account = accounts[0];
      instance.setActiveAccount(account);

      const userData = {
        name: account.name,
        username: account.username,
      };

      setUser(userData);

      try {
        const resp = await vscService.getUserByMail(account.username);
        const usuarioBD = resp?.content?.usuario;
        setUserInDatabase(!!resp?.content.usuario);
        if (usuarioBD) {
          const userDataCompleto = {
            ...usuarioBD,
            name: account.name,
            email: account.username,
            username: account.username,
            token: "msal-authenticated"
          };

          setUser(userDataCompleto);
          setUserInDatabase(true);
          System.setUser(userDataCompleto);
        } else {
          setUser(null);
          setUserInDatabase(false);
          System.setUser(null);
        }
      } catch {
        setUserInDatabase(false);
      }
      setLoading(false);
    };

    validarUsuario();
  }, [accounts, instance]);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        isAuthenticated: !!user,
        userInDatabase,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth fuera de AuthProvider");
  return ctx;
};
